import React, { Fragment  } from 'react';
import { func } from 'prop-types';
import { useSelector } from '../../common/react-redux-hooks';
import PreviewHeader from './PreviewHeader';
import PreviewBody from './PreviewBody';
import TargetWarningToast from './TargetWarningToast';

const PreviewSection = ({ removeAllTargets }) => {
  const { 
    deBuildTargets,
  } = useSelector(state => ({
    deBuildTargets: state.deBuild.deBuildTargets,
  }));


  const failedtargets = deBuildTargets.filter(item => item.isFailed || item.isDuplicate);
  return (
    <Fragment>
      <div className="de--build--lable">Preview</div>
      <div className="de--build--preview">
        { failedtargets.length > 0 && (
          <TargetWarningToast
            type="FAIL"
            title="Couldn’t update name"
            message="Name already exists, enter a unique name."
            successCount={0}
          />
        )}
        {/* {savedListCount > 0 &&
          <TargetWarningToast 
            type='success'
            title='Saved'
            message='successfully saved' 
            successCount={savedListCount}
          />
        } */}
        <PreviewHeader removeAllTargets={removeAllTargets} />
        <PreviewBody failedTarget={failedtargets.length} />
      </div>
    </Fragment>
  );
};

PreviewSection.propTypes = {
  removeAllTargets: func,
};

export default PreviewSection;
